import React from 'react' 
import { MdKeyboardArrowLeft, MdKeyboardDoubleArrowRight } from 'react-icons/md'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import profile from '../../assets/images/admin img.png'
import { IoIosCheckmarkCircle } from "react-icons/io";


function ViewUser() {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state?.type ?? 0
  return (
    <>
      <div className='row justify-content-center mx-4'>
        <div className='d-flex align-items-center justify-content-between p-0'>
            {state === 1 ?
             <>
            <h4 className='header-title mb-0 text-muted mt-3'>View User</h4>
            </>
            : 
            <>
              <h4 className='header-title mb-0 text-muted mt-3'>
            <Link onClick={()=>navigate(-1)} className='header-sub-title'>
              All User
            </Link>
            <span className="blr-player-view">
              <MdKeyboardDoubleArrowRight className='jumbo-red-text mb-1 ms-2 '/>
            </span>{' '}
            View User
          </h4>
            </> 
          }
          {/* <h4 className='header-title mb-0 text-muted mt-3'>
            <Link onClick={()=>navigate(-1)} className='header-sub-title'>
              All User
            </Link>
            <span className="blr-player-view">
              <MdKeyboardDoubleArrowRight className='jumbo-red-text mb-1 ms-2 '/>
            </span>{' '}
            View User
          </h4> */}
          <button
            type='button'
            className='btn text-white mt-3 d-flex'
            onClick={() => navigate(-1)}
          >
            <MdKeyboardArrowLeft className=' fs-4' />
            Back
          </button>
        </div>

        <div className='row p-0 mt-3'> 
          <div className='col-12 col-md-6 col-lg-3 ps-0 pe-md-3 pe-sm-0 pe-0'>
            <div className='card py-3'>
              <div className='card-body d-flex justify-content-center'>
                <img
                  src={profile}
                  alt='Profile'
                  className='img-thumbnail blr-user-image'
                />
              </div>
              <div className='pt-1'>
                <hr className='hr-color'/>
              </div>
              <div className='d-flex flex-column align-items-center py-3 '>
                <h5>Tester Test</h5> 
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6 col-lg-9 px-0'>
            <div className='card'>
              <div className='card-body'>  
                <div className='row py-2 mb-3'>

                  <div className='mb-2 col-12 col-md-3'>
                    <label htmlFor='totaldeposits' className='form-label'>
                   Total Deposits
                    </label>
                    <input
                      type='text'
                      className='form-control disabled-input-color'
                      id='totaldeposits'
                      placeholder='0'
                      style={{background : "#7e7e7e38"}}
                      disabled
                    />
                  </div>

                  <div className='mb-2 col-12 col-md-3'>
                    <label htmlFor='totalwithdrawals' className='form-label'>
                    Total Withdrawals
                    </label>
                    <input
                      type='text'
                      className='form-control disabled-input-color'
                      id='totalwithdrawals' 
                      placeholder='12'
                      style={{background : "#7e7e7e38"}}
                      disabled
                    />
                  </div>

                  <div className='mb-2 col-12 col-md-3'>
                    <label htmlFor='availablebalance' className='form-label'>
                    Total Available Balance
                    </label>
                    <input
                      type='text'
                      className='form-control disabled-input-color'
                      id='availablebalance'
                      placeholder='32'
                      style={{background : "#7e7e7e38"}}
                      disabled
                    />
                  </div>

                  <div className='mb-2 col-12 col-md-3'>
                    <label htmlFor='wininng' className='form-label'>
                   Total Winnings
                    </label>
                    <input
                      type='text'
                      className='form-control disabled-input-color'
                      id='wininng'
                      placeholder='987.00'
                      style={{background : "#7e7e7e38"}}
                      disabled
                    />
                  </div>  
                </div>

                  <div className='row '>

                    <div className='col-12 col-md-12 col-lg-6 '>
                      <div className='table-responsive'>
                        <table className='table '>
                          <tbody className='blr-line-height-table '>
                            <tr>
                              <td className='fw-bold'>Usename</td>
                              <td>testing</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td className='fw-bold'>Phone</td>
                              <td>
                                  <span className='badge badge-success-lighten' style={{fontSize:'13px'}}>3213213210</span>
                                </td>
                              <td className='fw-bold'></td>
                            </tr>
                            <tr>
                              <td className='fw-bold'>Email</td>
                              <td>test@gmail.com</td>
                              <td>
                                <IoIosCheckmarkCircle  className='text-primary fs-5'/>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <div className='col-12 col-md-12 col-lg-6 '>
                      <div className='table-responsive'>
                        <table className='table '>
                          <tbody className='blr-line-height-table '>
                            <tr>
                              <td className='fw-bold'>Fullname</td>
                              <td>John doe</td>
                            </tr>
                            <tr>
                              <td className='fw-bold'>Gender</td>
                              <td>
                                Male
                              </td>
                            </tr>
                            <tr>
                              <td className='fw-bold'>Date of Birth</td>
                              <td>12-11-2002</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div> 
                </div> 
              </div>
            </div>
          </div>
        </div>

        {/* address */}
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="mb-2 col-md-8">
                <label htmlFor="address" className="form-label">
                  Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  defaultValue="vishwas villa, ghanshyaham nagar, bherai road, rajula city, Rajula, Rajula, Amreli, Rajula, Gujarat, India, 365560"
                  style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div>
              <div className="mb-3 col-md-4">
                <label htmlFor="city" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  defaultValue="Ahmedabad"
                  style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div>
              <div className="mb-3 col-md-3">
                <label htmlFor="state" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="state"
                  defaultValue="Gujarat"
                   style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="country" className="form-label">
                  Country
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  defaultValue="India"
                   style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div>
              <div className="mb-1 col-md-3">
                <label htmlFor="zipcode" className="form-label">
                  Zip Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="zipcode"
                  defaultValue={365560}
                   style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div> 
              <div className="mb-1 col-md-3">
                <label htmlFor="since" className="form-label">
                  Since
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="since"
                  defaultValue="2024-09-18 14:36:36"
                   style={{background : "#7e7e7e38"}}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        {/* address end */}

      {/* buttons cards */}
      <div className="row p-0">
        <div className="col-xl-12 p-0">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
              <div className="card widget-flat justify-content-center">
                <div className="card-body widget-flat-body">
                  <div className="text-center">
                    <h3 className="mt-3 mb-3 text-muted">Total Deposits</h3>
                  </div>
                  <div className="text-center">
                    <h3 className="mt-3 mb-3">
                      <span className="badge badge-success-lighten">
                        <i className="mdi mdi-currency-inr" />
                        2,200
                      </span>
                    </h3>
                  </div>
                  <div className="text-center">
                    <Link
                      type="button" 
                      className="btn text-white "
                    >
                      View all
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
              <div className="card widget-flat justify-content-center">
                <div className="card-body widget-flat-body">
                  <div className="text-center">
                    <h3 className="mt-3 mb-3 text-muted">Total Withdrawals</h3>
                  </div>
                  <div className="text-center">
                    <h3 className="mt-3 mb-3">
                      <span className="badge badge-primary-lighten">
                        <i className="mdi mdi-currency-inr" />321
                      </span>
                    </h3>
                  </div>
                  <div className="text-center">
                    <Link
                      type="button" 
                      className="btn  text-white "
                    >
                      View all
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
              <div className="card widget-flat justify-content-center">
                <div className="card-body widget-flat-body">
                  <div className="text-center">
                    <h3 className="mt-3 mb-3 text-muted">Total Available Balance</h3>
                  </div>
                  <div className="text-center">
                    <h3 className="mt-3 mb-3">
                      <span className="badge badge-danger-lighten">
                        <i className="mdi mdi-currency-inr" />
                        728.1
                      </span>
                    </h3>
                  </div>
                  <div className="text-center">
                    <Link
                      type="button" 
                      className="btn  text-white "
                    >
                      View all
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
              <div className="card widget-flat justify-content-center">
                <div className="card-body widget-flat-body">
                  <div className="text-center">
                    <h3 className="mt-3 mb-3 text-muted">Total Winnings</h3>
                  </div>
                  <div className="text-center">
                    <h3 className="mt-3 mb-3">
                      <span className="badge badge-success-lighten">
                        <i className="mdi mdi-currency-inr" />0
                      </span>
                    </h3>
                  </div>
                  <div className="text-center">
                    <Link
                      type="button" 
                      className="btn  text-white "
                    >
                      View all
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
      {/* buttons cards end */}

    </div>
    </>
  )
}

export default ViewUser
